import { apiJson, type ApiFetchInit } from "../../api/client";

export interface ResendVerificationResult {
  sent: boolean;
  // Present (and true) when the user's current email is already verified —
  // general-api short-circuits without sending or rate-limiting.
  alreadyVerified?: boolean;
}

// AHA-39565 — re-issue the current user's verification email. Backed by the
// team-mgmt backend's POST /email-verification/resend, which proxies general-
// api as the current session (no body needed). The upstream 429 rate-limit
// surfaces as an ApiError whose `body.upstream.message` carries the reason —
// see useResendVerificationEmail.
export function resendVerificationEmail(
  init: ApiFetchInit = {},
): Promise<ResendVerificationResult> {
  return apiJson<ResendVerificationResult>("/email-verification/resend", {
    ...init,
    method: "POST",
  });
}
